module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/babel-runtime/regenerator/index.js
// module id = 531
// module chunks = 6